
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/DataFilter",
      function () {
        return require("private-next-pages/components/DataFilter.mdx");
      }
    ]);
  